import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { FrameInfo, IPageService, ITelemetryService } from '../interfaces';
import { isValidUrlForApp } from '../utils';
import { BaseMessageHandler } from './base-message-handler';
import { onStatusError } from './messageHandlingUtils';

/**
 * Responsible for pages module related message requests.
 */
export class PageMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected pageService?: IPageService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(SdkMessageTypes.pages.returnFocus, (_, params: boolean) =>
      this.pageService!.returnFocus(params)
    );
    this.registerHandler(SdkMessageTypes.pages.setCurrentFrame, this.handleSetCurrentFrame);
    this.registerHandler(SdkMessageTypes.pages.navigateCrossDomain, this.handleLoadCrossDomainUrl, {
      errorCallback: (error, scenario) => onStatusError(SdkMessageTypes.pages.navigateCrossDomain, error, scenario),
    });
  }

  protected validateDependencies() {
    if (!this.pageService) {
      throw 'No pageService provided';
    }
  }

  private handleSetCurrentFrame(_: MessageEvent, frameInfo: FrameInfo) {
    const context = this.appSdkHost.getContext();
    if (
      isValidUrlForApp(frameInfo.contentUrl, this.appDefinition, context) &&
      isValidUrlForApp(frameInfo.websiteUrl, this.appDefinition, context)
    ) {
      this.pageService!.setCurrentFrame(frameInfo);
    }
  }

  /**
   * Load cross-domain url in frame
   */
  protected async handleLoadCrossDomainUrl(_: MessageEvent, url: string): Promise<boolean> {
    await this.appSdkHost.load(url);
    return Promise.resolve(true);
  }
}
